import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function MonthFilter_datepicker({ label, value, onChange }) {
  const selectedDate =
    value.year && value.month
      ? new Date(value.year, value.month - 1, 1) 
      : null;
  const today = new Date();
  const maxSelectableDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  return (
    <div style={{ position: "relative", zIndex: 10 }} className="Inner_month_date_filter">
      <label>{label}</label>
      <DatePicker
        selected={selectedDate}
        className="form-control s"     // ✅ full-width input
        onChange={(date) => {
          if (!date) {
            onChange({ month: "", year: "" });
            return;
          }

          onChange({
            month: date.getMonth() + 1,
            year: date.getFullYear(),
          });
        }}
        showMonthYearPicker
        dateFormat="MMMM yyyy"
        isClearable
        placeholderText="Select month"
        popperPlacement="bottom-start"
        maxDate={maxSelectableDate}
        renderMonthContent={(monthIndex, shortMonthText) => (
          <div
            style={{
              padding: "7px 12px",
              margin: "5px 0px",
              borderRadius: "6px",
              display: "inline-block",
              width: "60px",
              textAlign: "center",
            }}
          >
            {shortMonthText}
          </div>
        )}
      />
    </div>
  );
}
